module.exports = __webpack_public_path__ + "media/images/niq-left-1c7396b58460e8601c7ce5179e17add9.svg";